import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import rejectIcon from "../../assets/images/reject.png"; 
import Money from "../../assets/images/money.png"; 
import { useTranslation } from "react-i18next";

const ProjectDetails = () => {
  const location = useLocation();
  const project = location?.state?.project;

  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  // const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [popupType, setPopupType] = useState(null); // 'accept' | 'reject' | 'reject-success'
  const [rejectReason, setRejectReason] = useState("");
console.log(project)
  // // Fetch project details (uncomment when API ready)
  // const fetchProjectDetails = async () => {
  //   try {
  //     const res = await ApiService.request({
  //       method: "GET",
  //       url: `/getProjectDetails?project_id=${projectId}`,
  //     });
  //     if (res.data.status) setProject(res.data.data);
  //     else toast.error(res.data.message);
  //   } catch (error) {
  //     toast.error("Failed to fetch project details");
  //     console.error(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   if (projectId){

  //     fetchProjectDetails();
  //   }
  // }, [projectId]);

  // --- Update Status Function ---
  const handleUpdateStatus = async (status, reason = "") => {
    try {
      setIsLoading(true);
      const formdata = new FormData();
      formdata.append("project_id", project._id);
      formdata.append("status", status);
      if (status === "Rejected") formdata.append("reject_reason", reason);

      const res = await ApiService.request({
        method: "POST",
        url: `projects/updateStatus`,
        data: formdata,
      });

      if (res.data.status) {
        toast.success(res.data.message);
        if (status === "Accepted") setPopupType("accept");
        else setPopupType("reject-success");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to update project status.");
    } finally {
      setIsLoading(false);
    }
  };


  return (
     <div className="container py-4">
      <div 
        className="bg-white shadow-sm p-4 rounded-4" 
        style={{ 
          maxWidth: "1005px", 
          margin: "0 auto",
          textAlign: isRTL ? "right" : "left"
        }}
      >
        <h3 className="fw-bold mb-3" style={{ fontSize: "28px" }}>
          {t("project_offer_detail")} {/* Project Offer Detail */}
        </h3>

        <h6 className="text-dark fw-bold">{t("project_name")}</h6>
        <p style={{ direction: "ltr" }}>{project?.project_id?.title || ""}</p>

        <h6 className="text-dark fw-bold mt-3">{t("project_details")}</h6>
        <p className="text-secondary" style={{ direction: "ltr" }}>{project?.project_id?.description || ""}</p>

        <div className="row mt-4">
          <div className="col-md-4">
            <p className="text-muted m-0">{t("skill")}</p>
            <p className="fw-semibold" style={{ direction: "ltr" }}>{project?.skill_id?.title || ""}</p>
          </div>
          <div className="col-md-4">
            <p className="text-muted m-0">{t("subskill")}</p>
            <p className="fw-semibold" style={{ direction: "ltr" }}>{project?.sub_skill_id?.title || ""}</p>
          </div>
          <div className="col-md-4">
            <p className="text-muted m-0">{t("duration")}</p>
            <p className="fw-semibold" style={{ direction: "ltr" }}>{project?.duration ? `${project.duration}` : "—"}</p>
          </div>
        </div>

        <div className="row mt-3">
         <div className="col-md-4">
  <p className="text-muted m-0" style={{ textAlign: isRTL ? "right" : "left" }}>{t("budget")}</p>
  <p className="fw-semibold d-flex align-items-center gap-1" style={{ 
    direction: "ltr",
    textAlign: isRTL ? "right" : "left",
    justifyContent: isRTL ? "flex-end" : "flex-start"
  }}> 
    <img
      src={Money}
      alt="AUD"
      width="14"
      height="12"
    /> {project?.total_amount?.toLocaleString() || ""} AED
  </p>
</div>
          <div className="col-md-4">
            <p className="text-muted m-0">{t("contract_type")}</p>
            <p className="fw-semibold" style={{ direction: "ltr" }}>{project?.job_type || ""}</p>
          </div>
          <div className="col-md-4">
            <p className="text-muted m-0">{t("dates")}</p>
            <p className="fw-semibold" style={{ direction: "ltr" }}>
              {project?.start_date && project?.end_date
                ? `${new Date(project.start_date).toLocaleDateString()} - ${new Date(project.end_date).toLocaleDateString()}`
                : "N/A"}
            </p>
          </div>
        </div>

        {project?.status === "Pending" &&
          <div className="d-flex flex-wrap justify-content-end mt-4 gap-3">
            <Button
              className="border-0 p-3 mt-3 flex-grow-1"
              style={{
                backgroundColor: "#E5E4E4",
                color: "#474747",
                padding: "10px 0",
                fontWeight: "500",
                fontSize: "15px",
                borderRadius: "15px",
                maxWidth: "147px",
              }}
              onClick={() => setPopupType("reject")}
            >
              {t("reject_offer")} {/* Reject Offer */}
            </Button>

            <Button
              className="border-0 p-3 mt-3 flex-grow-1"
              style={{
                backgroundColor: "#FF5C35",
                color: "#fff",
                padding: "10px 0",
                fontWeight: "500",
                fontSize: "15px",
                borderRadius: "15px",
                maxWidth: "147px",
              }}
              onClick={() => handleUpdateStatus("Accepted")}
            >
              {t("accept_offer")} {/* Accept Offer */}
            </Button>
          </div>
        }
        {project?.status === "Rejected" &&
         <p className="alert alert-danger fw-bold mt-3">{t("offer_rejected")}</p>
        }
        {(project?.status === "Accepted" && project?.payment_status === "Pending") &&
         <p className="alert alert-warning fw-bold mt-3">{t("in_progress")}</p>
        }
        {(project?.status === "Accepted" && project?.payment_status === "Paid") &&
         <p className="alert alert-success fw-bold mt-3">{t("hired")}</p>
        }

        <style jsx>{`
          @media (max-width: 768px) {
            .d-flex.flex-wrap {
              flex-direction: column !important;
              align-items: stretch !important;
            }

            .d-flex.flex-wrap button {
              max-width: 100% !important;
            }
          }
        `}</style>
      </div>

      {/* ===== ACCEPT POPUP ===== */}
      {popupType === "accept" && (
        <Popup
          title={t("offer_accepted_success")} // "Offer Accepted Successfully!"
          description={t("offer_sent_to_company")} // "We have sent your offer to the company to proceed with the hiring process."
          type="success"
          onClose={() => setPopupType(null)}
        />
      )}

      {/* ===== REJECT INPUT POPUP ===== */}
      {popupType === "reject" && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ backdropFilter: "blur(2px)" }}
          onClick={() => setPopupType(null)}
        >
          <div
            className="bg-white text-center p-5 rounded-4 shadow"
            style={{ 
              maxWidth: 500, 
              width: "90%",
              textAlign: isRTL ? "right" : "left"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-3">
              <div className="mx-auto d-flex justify-content-center align-items-center">
                <img
                  src={rejectIcon}
                  alt="Reject"
                  style={{ width: 55, height: 55, objectFit: "contain" }}
                />
              </div>
            </div>
            <h5 className="fw-bold mb-3" style={{ fontSize: "24px" }}>
              {t("reject_offer")} {/* Reject Offer */}
            </h5>
            <p className="text-secondary mb-4">
              {t("provide_rejection_reason")} {/* Please provide the rejection reason */}
            </p>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder={t("enter_reason")} // "Enter reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              style={{ height: "80px", resize: "none" }}
            />
            <Button
              className="w-100 border-0 p-3 mt-3"
              style={{
                backgroundColor: "#FF5C35",
                padding: "10px 0",
                fontWeight: "500",
                fontSize: "15px",
                borderRadius: "15px",
              }}
              onClick={() => {
                if (!rejectReason.trim()) {
                  toast.error(t("enter_rejection_reason")); // "Please enter rejection reason"
                  return;
                }
                handleUpdateStatus("Rejected", rejectReason);
                setRejectReason("");
              }}
            >
              {t("submit")} {/* Submit */}
            </Button>
          </div>
        </div>
      )}

      {/* ===== REJECT SUCCESS POPUP ===== */}
      {popupType === "reject-success" && (
        <Popup
          title={t("offer_rejected")} // "Offer Rejected"
          description={t("response_submitted")} // "We have submitted your response. For more information, Nahham team may contact with you."
          iconColor="#FF5C35"
          onClose={() => setPopupType(null)}
        />
      )}
    </div>
  );
};

// ===== REUSABLE POPUP COMPONENT =====


const Popup = ({ title, description, type = "reject", onClose }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    onClose?.(); // if you have a function to close the popup
    navigate("/talent/projects");
  };
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  // Choose icon color and SVG based on type
  const isSuccess = type === "success";
  const iconColor = isSuccess ? "#28a745" : "#FF5c35"; // green or red
  const iconSvg = isSuccess ? (
    // ✅ SUCCESS ICON
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="white" viewBox="0 0 16 16">
      <path d="M13.485 1.929a.75.75 0 0 1 1.03 1.092l-8 9a.75.75 0 0 1-1.08.02l-4-4a.75.75 0 0 1 1.06-1.06l3.47 3.47 7.52-8.522z" />
    </svg>
  ) : (
  
     <img
    src={rejectIcon}
    alt="Reject"
    style={{ width: 32, height: 32, objectFit: "contain" }}
  />
  );

  return (
   <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
      style={{ backdropFilter: "blur(2px)", zIndex: 1050 }}
      onClick={onClose}
    >
      <div
        className="bg-white text-center p-5 rounded-4 shadow"
        style={{
          maxWidth: 500,
          width: "90%",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
          textAlign: isRTL ? "right" : "left"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ICON */}
        <div className="mb-3">
          <div
            className="mx-auto d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: iconColor,
              width: 60,
              height: 60,
              borderRadius: "50%",
            }}
          >
            {iconSvg}
          </div>
        </div>

        {/* TITLE + DESCRIPTION */}
        <h5 className="fw-bold mb-2" style={{ fontSize: "25px" }}>
          {title}
        </h5>
        <p className="text-secondary mb-4" style={{ fontSize: 15 }}>
          {description}
        </p>

        {/* CLOSE BUTTON */}
        <Button
          className="w-100 border-0"
          style={{
            backgroundColor: "#FF5C35",
            padding: "10px 0",
            fontWeight: "500",
            fontSize: "15px",
            borderRadius: "15px",
          }}
          onClick={handleClose}
        >
          {t("c_t_close")} {/* Close */}
        </Button>
      </div>
    </div>
  );
};



export default ProjectDetails;
